import { render } from "./HermesTenantSwitcher.vue?vue&type=template&id=4e8fbdab&scoped=true"
import script from "./HermesTenantSwitcher.vue?vue&type=script&lang=js"
export * from "./HermesTenantSwitcher.vue?vue&type=script&lang=js"

import "./HermesTenantSwitcher.vue?vue&type=style&index=0&id=4e8fbdab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8fbdab"]])

export default __exports__